import components from "./src/components"
import config from "./src/config"
import directives from "./src/directives/client"
import plugins from "./src/plugins"
import axios from 'axios'

export default {
  // Default export is a Vue plugin
  install (Vue, options) {
    const isNuxt = options && options.isNuxt
    if (!isNuxt) {
      // Provide global CSS via direct import
      require('./src/styles/functions/_index.scss')
      require('./src/styles/base/_index.scss')
      require('./src/styles/helpers/_index.scss')
      require('./src/styles/animations/_index.scss')
    }

    // Register all components from library into main Vue instance
    Object.entries(components).forEach(([name, file]) => {
      Vue.component(name, file)
    })

    // Register all directives from library
    Object.entries(directives).forEach(([name, options]) => {
      Vue.directive(name, options)
    })

    // Register all plugins from library
    Object.entries(plugins).forEach(([name, plugin]) => {
      Vue.use(plugin, {name: name})
    })

    // Create an instance property with all the config of the library
    // Read more about instance properties on https://vuejs.org/v2/cookbook/adding-instance-properties.html#Base-Example
    const baseUrlApi = (options && options.baseUrlApi) || 'https://api.eo.nl'
    Vue.prototype.$library = {
      api: axios.create({ baseURL: `${baseUrlApi}` }),
      ...config,
      ...options, // configuration of the library
    }
  },
}
